import { autobind } from 'core-decorators';
import { Component } from 'react';
import SoyCycleChart from '/@/components/soy-cycle-chart';
import { _, _lazy } from '/@/locale';

import styles from './styles.module.css';

@autobind
export default class SoyCycle extends Component {
    static label = _lazy('Ventana de siembra maíz safrinha');
    static icon = 'plantingWindow';

    render() {
        return (
            <div className={styles.root}>
                <p>{_('Influencia del ciclo de la soja en la disponibilidad de agua en el maíz safrinha.')}</p>
                <SoyCycleChart
                    plantingDate={this.props.cropConfig.plantingDate}
                    products={this.props.productRecommendations.map(({ profile }) => profile)}
                />
            </div>
        );
    }
}
